import * as Types from '../../generated/types.cms';

import { endpoint, fetchParams } from '@payflip/employee-client/cms-gql-config';
import { useQuery, UseQueryOptions } from 'react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpoint as string, {
    method: "POST",
    ...(fetchParams),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type GetEmailNotVerifiedPageLocalesQueryVariables = Types.Exact<{
  locale: Types.Scalars['I18NLocaleCode']['input'];
}>;


export type GetEmailNotVerifiedPageLocalesQuery = { __typename?: 'Query', common?: { __typename?: 'CommonEntityResponse', data?: { __typename?: 'CommonEntity', id?: string | null, attributes?: { __typename?: 'Common', emailNotVerifiedHeader?: string | null, emailNotVerifiedBody?: string | null, emailNotVerifiedFooter?: string | null, emailNotVerifiedResend?: string | null, emailNotVerifiedResendSuccess?: string | null, emailNotVerifiedResendError?: string | null, logoutDescription?: string | null, logoutButton?: string | null } | null } | null } | null };



export const GetEmailNotVerifiedPageLocalesDocument = `
    query GetEmailNotVerifiedPageLocales($locale: I18NLocaleCode!) {
  common(locale: $locale) {
    data {
      id
      attributes {
        emailNotVerifiedHeader
        emailNotVerifiedBody
        emailNotVerifiedFooter
        emailNotVerifiedResend
        emailNotVerifiedResendSuccess
        emailNotVerifiedResendError
        logoutDescription
        logoutButton
      }
    }
  }
}
    `;

export const useGetEmailNotVerifiedPageLocalesQuery = <
      TData = GetEmailNotVerifiedPageLocalesQuery,
      TError = unknown
    >(
      variables: GetEmailNotVerifiedPageLocalesQueryVariables,
      options?: UseQueryOptions<GetEmailNotVerifiedPageLocalesQuery, TError, TData>
    ) => {
    
    return useQuery<GetEmailNotVerifiedPageLocalesQuery, TError, TData>(
      ['GetEmailNotVerifiedPageLocales', variables],
      fetcher<GetEmailNotVerifiedPageLocalesQuery, GetEmailNotVerifiedPageLocalesQueryVariables>(GetEmailNotVerifiedPageLocalesDocument, variables),
      options
    )};
